<mat-toolbar class="bar-filler">
    <div></div>
</mat-toolbar>
<mat-list *ngIf="!isLoading" style="padding: 0; margin: 0;">
    <mat-list-item *ngFor="let adress of adressList" matRipple class="no-outline pointer-cursor flex-container-center" style="height: auto;" (click)="adressTap(adress)">
        <div class="small-margin flex-container-center">
            <div>
                <div class="label block">{{adress.Location}}</div>
                <div class="detail block"> {{adress.FullAdress}}</div>
            </div>
        </div>
        <button *ngIf="showDelete" mat-icon-button color="accent" (click)="deleteAdress()">
            <mat-icon>delete</mat-icon>
        </button>
        <mat-divider></mat-divider>
    </mat-list-item>
</mat-list>
<mat-toolbar color="primary" class="top-bar">
    <button mat-icon-button (click)="back()">
        <mat-icon>arrow_back</mat-icon>
    </button>
    <div>{{'Pages.AdressPicker.Title' | translate}}</div>
    <div class="filler"></div>
    <button mat-icon-button (click)='addAdress()'>
        <mat-icon>add</mat-icon>
    </button>
</mat-toolbar>
<div *ngIf="isLoading" class="floating-container">
    <mat-spinner></mat-spinner>
    <p class="floating-label">{{'Pages.ConfirmAddress.SavingMessage' | translate}}</p>
</div>